export default __webpack_public_path__ + "static/media/copyrightLogo.f1179afd.png";